
<template>
    <div class="modal-container position-fixed w-100 h-100 d-flex flex-column overflow-auto p-2" :class="customClass" v-if="show" @click.self="show=false">
        <div class="modal-content d-flex flex-column bg-white mx-auto my-auto">
            <div class="modal-content__header d-flex align-items-center p-3">
                <slot name="header">
                    <div class="modal-content__header-title">
                        {{title}}
                    </div>
                </slot>
                <div class="modal-close-button ml-auto">
                    <button class="modal-button-close" type="button" @click="closeModal">×</button>
                </div>
            </div>
            <div class="modal-content__body">
                <slot>
                    No content
                </slot>
            </div>
            <div class="modal-content__footer">
                <slot name="footer">
                    <!-- content footer -->
                </slot>
            </div>
        </div>
    </div>
</template>

<script>

export default ({
    /** 
     * Comment
     */
    name: "Modal",

    props: {
        title: {
            type: String,
            default: ''
        },
        customClass: {
            type: String,
            default: ''
        },
        afterClose: {
            type: Function,
            default: ()=>{}
        }
    },

    data() {
        return {
        show: false
        };
    },

    /**
     * to call this component functions put a ref on the component and call the function through it, example:
     * <modal ref="modalComponent"> ... </modal>
     * <button @click="$refs.modalComponent.openModal()">open</button>
     */
    methods: {
        closeModal() {
            this.show = false;
            this.afterClose()
        },
        openModal() {
            this.show = true;
        },
    },

})
</script>

<style scoped>
    .modal-button-close{
        font-family: inherit;
        font-size: 1.5rem;
        font-weight: 700;
        line-height: 1;
        background-color: transparent;
        border: none;
        outline:none;
        color: #000;
        text-shadow: 0 1px 0 #fff;
        opacity: .5;
    }
    .modal-content__header{
        border-bottom: 1px solid rgba(0,0,0,.2);
    }
    .modal-content__header-title{
        line-height: 1.5;
        font-size: 1.25rem;
        font-weight: 500;
    }
    .modal-container{
        box-sizing: border-box;
        z-index: 1020;
        background-color: #0000005a;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
    }

    .modal-content{
        box-sizing: border-box;
        width: fit-content;
        max-width: 300px;
    }
</style>